const fabRegistrationEditorConfig = {
  initialContent: {
    divisions_section_title: "",
    divisions_text: "",

    locations_section_title: "",
    location_names_text: "",
    location_schedules_text: "",
    location_start_dates_text: "",
    location_urls_text: "",

    register_section_title: "",
    register_section_subtitle: "",

    team_registration_button_label: "",
    team_registration_url: "",
    team_registration_details_text: "",

    player_registration_button_label: "",
    player_registration_url: "",
    player_registration_details_text: "",

    free_agent_registration_button_label: "",
    free_agent_registration_url: "",
    free_agent_registration_details_text: "",

    oc_imprints_url: "",
    bottom_announcement: "",
  },

  loadContent(content = {}) {
    return {
      ...this.initialContent,
      ...content,
    };
  },

  buildContent(templateState = {}) {
    return {
      divisions_section_title:
        templateState.divisions_section_title?.trim() || "",
      divisions_text:
        templateState.divisions_text?.trim() || "",

      locations_section_title:
        templateState.locations_section_title?.trim() || "",
      location_names_text:
        templateState.location_names_text?.trim() || "",
      location_schedules_text:
        templateState.location_schedules_text?.trim() || "",
      location_start_dates_text:
        templateState.location_start_dates_text?.trim() || "",
      location_urls_text:
        templateState.location_urls_text?.trim() || "",

      register_section_title:
        templateState.register_section_title?.trim() || "",
      register_section_subtitle:
        templateState.register_section_subtitle?.trim() || "",

      team_registration_button_label:
        templateState.team_registration_button_label?.trim() || "",
      team_registration_url:
        templateState.team_registration_url?.trim() || "",
      team_registration_details_text:
        templateState.team_registration_details_text?.trim() || "",

      player_registration_button_label:
        templateState.player_registration_button_label?.trim() || "",
      player_registration_url:
        templateState.player_registration_url?.trim() || "",
      player_registration_details_text:
        templateState.player_registration_details_text?.trim() || "",

      free_agent_registration_button_label:
        templateState.free_agent_registration_button_label?.trim() || "",
      free_agent_registration_url:
        templateState.free_agent_registration_url?.trim() || "",
      free_agent_registration_details_text:
        templateState.free_agent_registration_details_text?.trim() || "",

      oc_imprints_url:
        templateState.oc_imprints_url?.trim() || "",
      bottom_announcement:
        templateState.bottom_announcement?.trim() || "",
    };
  },

  getStep2Props({
    templateState,
    setTemplateField,
  }) {
    return {
      templateState,
      setTemplateField,
    };
  },
};

export default fabRegistrationEditorConfig;